module.exports = (__webpack_require__(46626))(6540);